import { CSSProperties, ReactNode } from 'react';

import styles from './Button.module.css';

type ButtonProps = {
  children: ReactNode;
  type:
    | 'primary'
    | 'light-grey'
    | 'dark-grey'
    | 'delete'
    | 'warn'
    | 'transparent'
    | 'white';
  width: 'full-width' | 'content-width';
  form?: 'rounded' | 'initial';
  isReadOnly?: boolean;
  onClick?: () => void;
  style?: CSSProperties;
};

const Button = ({
  type,
  width,
  children,
  form = 'initial',
  isReadOnly = false,
  onClick = undefined,
  style = undefined,
}: ButtonProps) => (
  <button
    type='button'
    style={style}
    className={`${styles.button} ${styles[type]} ${styles[width]} ${styles[form]} ${isReadOnly ? styles.disabled : ''}`}
    onClick={() => {
      if (!isReadOnly) {
        void onClick?.();
      }
    }}
  >
    {children}
  </button>
);

export default Button;
